import { StartScrapeNowMutation, StartScrapeNowMutationVariables } from 'types/graphql'

import { useMutation } from 'src/utils/queryClient'

const StartScrapeNow = gql`
  mutation StartScrapeNowMutation($scrapeTemplateId: Int!) {
    startScrapeNow(scrapeTemplateId: $scrapeTemplateId) {
      ...ScrapeFragment
    }
  }
`
export const useStartScrapeNowMutation = () => {
  return useMutation<StartScrapeNowMutation, StartScrapeNowMutationVariables>({
    mutationDocument: StartScrapeNow,
  })
}
